var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { memo } from 'react';
import TransferComponent from 'app/components/transferModule/content/transfer/TransferComponent';
import { View } from 'app/components/transferModule/content/commonStyles';
import styled from 'styled-components';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
const Filler = styled.div.withConfig({
  componentId: "sc-dcxlts-0"
})(["height:", ";width:100%;", ""], SIZES['56'], props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    max-width: 477px;\n  "]))));
const VerticalLine = styled.div.withConfig({
  componentId: "sc-dcxlts-1"
})(["display:none;", ""], props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n    width: 1px;\n    background-color: ", ";\n    position: absolute;\n    top: ", ";\n    left: 50%;\n    bottom: ", ";\n  "])), COLORS.lightGrey, SIZES['16'], SIZES['24']));
const TransfersView = /*#__PURE__*/memo(function TransfersView(_ref) {
  let {
    transferList
  } = _ref;
  return /*#__PURE__*/React.createElement(View, null, transferList.map((transfer, elementIndex) => {
    if (!transfer) {
      return /*#__PURE__*/React.createElement(Filler, {
        key: "transfer-filler-".concat(elementIndex)
      });
    }
    return /*#__PURE__*/React.createElement(TransferComponent, {
      key: transfer.getKey(),
      transfer: transfer
    });
  }), /*#__PURE__*/React.createElement(VerticalLine, null));
});
export default TransfersView;